var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-avatar',{attrs:{"size":_vm.size,"src":_vm.avatar,"shape":_vm.shape,"alt":_vm.alt,"fit":_vm.fit},on:{"error":_vm.error}},[_c('img',{attrs:{"src":require("../assets/empty-cube-image.png"),"alt":"empty image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }